import { useEffect, useState } from "react";
import { G } from "../../styles/theme";

export default function ScrollProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const h = () => { const el = document.documentElement; setPct((el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100 || 0); };
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, height: 3, zIndex: 9999, background: "rgba(255,255,255,.1)" }}>
      <div style={{ height: "100%", background: G.orange, width: pct + "%", transition: "width .1s", borderRadius: "0 2px 2px 0" }} />
    </div>
  );
}
